import { Field, FieldFooter } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import { MediaEntryUploader } from '../../..';
import { IMediaEntryUploaderValue } from '../../../../types/FileUploader';
import { IMediaEntry } from '../../../../types/MediaEntry';
import './MediaEntryFormField.scss';

interface IProps {
  className?: string | object;
  form: any;
  name: string;
  onChange?: (value: IMediaEntryUploaderValue) => void;
  mediaEntries: IMediaEntry[]; // Present already existing media entries in the header
  validations?: any;
}

function MediaEntryFormField(props: IProps) {
  const { form, name, validations, mediaEntries, className, onChange, ...other } = props;

  const classes = classNames(
    {
      'media-entry-form-field': true,
    },
    className
  );

  function renderField({ ...fieldProps }) {
    function handleOnChange(files: IMediaEntryUploaderValue) {
      fieldProps.handleChange(files, onChange);
    }

    return (
      <>
        <MediaEntryUploader mediaEntries={mediaEntries} onChange={handleOnChange} {...other} />
        <FieldFooter errorMessage={fieldProps.errorMessage} hasError={fieldProps.hasError} />
      </>
    );
  }

  return <Field form={form} name={name} validations={validations} className={classes} render={renderField} />;
}

MediaEntryFormField.defaultProps = {
  mediaEntries: [],
};

export default MediaEntryFormField;
